/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateApplicationDto
 */
export interface CreateUpdateApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    applicationType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    brandApplicationPurchaserId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateApplicationDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    permissionEmployeeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    permissionEmployeeBossId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    elementName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    nip: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    pesel: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    place: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    countryId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateApplicationDto
     */
    countryIsMain?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    numbers: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateApplicationDto
     */
    flat: string;
}

/**
 * Check if a given object implements the CreateUpdateApplicationDto interface.
 */
export function instanceOfCreateUpdateApplicationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "applicationType" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "brandApplicationPurchaserId" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "permissionEmployeeId" in value;
    isInstance = isInstance && "permissionEmployeeBossId" in value;
    isInstance = isInstance && "elementName" in value;
    isInstance = isInstance && "profileId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "nip" in value;
    isInstance = isInstance && "pesel" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "place" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "flat" in value;

    return isInstance;
}

export function CreateUpdateApplicationDtoFromJSON(json: any): CreateUpdateApplicationDto {
    return CreateUpdateApplicationDtoFromJSONTyped(json, false);
}

export function CreateUpdateApplicationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateApplicationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applicationType': json['applicationType'],
        'description': json['description'],
        'teamId': json['teamId'],
        'brandApplicationPurchaserId': json['brandApplicationPurchaserId'],
        'active': json['active'],
        'companyId': json['companyId'],
        'permissionEmployeeId': json['permissionEmployeeId'],
        'permissionEmployeeBossId': json['permissionEmployeeBossId'],
        'elementName': json['elementName'],
        'profileId': json['profileId'],
        'name': json['name'],
        'shortname': json['shortname'],
        'nip': json['nip'],
        'pesel': json['pesel'],
        'postcode': json['postcode'],
        'place': json['place'],
        'street': json['street'],
        'countryId': !exists(json, 'countryId') ? undefined : json['countryId'],
        'countryIsMain': !exists(json, 'countryIsMain') ? undefined : json['countryIsMain'],
        'numbers': json['numbers'],
        'flat': json['flat'],
    };
}

export function CreateUpdateApplicationDtoToJSON(value?: CreateUpdateApplicationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applicationType': value.applicationType,
        'description': value.description,
        'teamId': value.teamId,
        'brandApplicationPurchaserId': value.brandApplicationPurchaserId,
        'active': value.active,
        'companyId': value.companyId,
        'permissionEmployeeId': value.permissionEmployeeId,
        'permissionEmployeeBossId': value.permissionEmployeeBossId,
        'elementName': value.elementName,
        'profileId': value.profileId,
        'name': value.name,
        'shortname': value.shortname,
        'nip': value.nip,
        'pesel': value.pesel,
        'postcode': value.postcode,
        'place': value.place,
        'street': value.street,
        'countryId': value.countryId,
        'countryIsMain': value.countryIsMain,
        'numbers': value.numbers,
        'flat': value.flat,
    };
}

